import autoBind     from 'react-autobind';
import React        from 'react';
import PropTypes    from 'prop-types';
import NumberFormat from 'react-number-format';
import classNames   from 'classnames';
import isNil        from 'lodash/isNil';

import { NOOP_FALSE } from '~/constants/callbacks';

class CurrencyInput extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);

    this.state = {
      value: !isNil(props.value) ? props.value : '',
      size:  props.size || null,
    };
  }

  componentDidUpdate(prevProps) {
    // Update internal state when value prop changes from parent
    const { value } = this.props;
    if (prevProps.value !== value) {
      this.setState({ value: !isNil(value) ? value : '' });
    }
  }

  onChange(obj, e) {
    const { onChange } = this.props;
    const newValue = obj.value;

    this.setState({ value: newValue }, () => {
      onChange(newValue);
    });
  }

  render() {
    const { value, size } = this.state;
    const { id, extraClassName, placeholder } = this.props;

    return (
      <NumberFormat
        id={id}
        value={value}
        thousandSeparator
        prefix="$"
        className={classNames('form-control', extraClassName)}
        allowNegative={false}
        isNumericString
        isAllowed={(vals, e) => (size ? vals.value.toString().length <= size : true)}
        onValueChange={this.onChange}
        placeholder={placeholder}
      />
    );
  }
}

CurrencyInput.defaultProps = {
  id:             null,
  value:          null,
  size:           null,
  onChange:       NOOP_FALSE,
  extraClassName: '',
  placeholder:    '',
};

CurrencyInput.propTypes = {
  id:       PropTypes.string,
  value:    PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  size:     PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  onChange:       PropTypes.func,
  extraClassName: PropTypes.string,
  placeholder:    PropTypes.string,
};

export default CurrencyInput;
